import { render, staticRenderFns } from "./requestView.vue?vue&type=template&id=614a499d"
import script from "./requestView.vue?vue&type=script&lang=js"
export * from "./requestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports